import React from 'react'
import Lottie from 'lottie-react'
import loaderData from '@meprism/shared/src/assets/lottie/Loader.json'
import { Box } from '@mui/material'

interface LottieLoaderProps {
  width?: number | string
  height?: number | string
}

const LottieLoader = ({ width = 150, height = 150 }: LottieLoaderProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Lottie
        animationData={loaderData}
        loop={true}
        style={{ width, height }}
      />
    </Box>
  )
}

export default LottieLoader
